import { addDays } from 'date-fns';
import type { TripSegmentType } from '../../../pages/result/models';
import type { TripDataType } from './models';

export const getSavedTrips = (): TripDataType[] => {
  try {
    const tripsData = localStorage.getItem('savedTrips');
    if (!tripsData) {
      return [];
    }
    const parsedTrips = JSON.parse(tripsData);
    if (new Date() > new Date(parsedTrips.expiry)) {
      localStorage.removeItem('savedTrips');
      return [];
    }
    return parsedTrips.data;
  } catch (error) {
    localStorage.removeItem('savedTrips');
    return [];
  }
};

export const setLocalStorage = (key: string, data: TripDataType[]) => {
  const expiryDate = addDays(new Date(), 3);
  expiryDate.setDate(expiryDate.getDate());
  localStorage.setItem(
    key,
    JSON.stringify({
      data,
      expiry: expiryDate.toString(),
    }),
  );
};

export const filterTripsInFuture = (savedTrips: TripDataType[]) => {
  return savedTrips.filter((trip) => {
    const firstSegment = trip.bounds[0]?.segments[0] as TripSegmentType;
    const departureAt = firstSegment?.departuredAt;
    return departureAt ? new Date(departureAt) > new Date() : false;
  });
};
